import React from 'react';
import EditPortalModal from './EditPortalModal';


const ConvertToPortalModal = ({ open, onClose, onSave, source, sourceType, boothName }) => {
  const syntheticPortal = source
    ? {
        localizedPairs:
          sourceType === 'media'
            ? { key: source.textKey, values: source.textLocalizations || [] }
            : source.localizedPairs,
        correspondingMedia:
          sourceType === 'media'
            ? { mediaTypeId: source.mediaTypeId, linkLocalizations: source.linkLocalizations || [] }
            : source.correspondingMedia,
        portalLinks: sourceType === 'custom' ? (source.links || []) : [],
      }
    : null;

  return (
    <EditPortalModal
      open={open}
      onClose={onClose}
      portals={syntheticPortal ? [syntheticPortal] : []}
      onSave={onSave}
      positionCount={3}
      boothName={boothName}
      title="Convert to Portal"
      saveLabel="Convert to Portal"
    />
  );
};

export default ConvertToPortalModal;
